module.exports = __webpack_public_path__ + "img/logo_lg_dark.e216d882.svg";